import { Attr, Model } from 'spraypaint';
import ApplicationRecord from '../ApplicationRecord';

/**
 * Request a fresh verification email.
 *
 * The endpoint **always reports generic success**, whether or not the address
 * exists and whether or not it is already verified - it deliberately reveals
 * nothing about accounts. Do not try to infer anything from a success response.
 *
 * It is rate limited (per-email cooldown plus an hourly cap per email and per
 * IP) and returns 429 when throttled. That is the only response worth
 * surfacing differently.
 */
@Model()
export default class EmailVerificationResend extends ApplicationRecord {
  static jsonapiType = 'email-verification-resends';

  static request(email: string) {
    return new EmailVerificationResend({ email }).save();
  }

  @Attr() email: string;
}
